module.exports = __webpack_public_path__ + "img/JDE2.b3e6c41c.png";